import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const STYLES = {
  lime: "bg-[#74DC26] text-[#082619] hover:bg-[#F9F8F3]",
  forest: "bg-[#082619] text-[#F9F8F3] hover:bg-[#12422c]",
  ghostLight: "border border-white/30 text-white hover:bg-white hover:text-[#082619]",
  ghostDark: "border border-[#082619]/25 text-[#082619] hover:bg-[#082619] hover:text-[#F9F8F3]",
};

export const CTAButton = ({ to, href, children, variant = "lime", className = "", testId, ...rest }) => {
  const cls = `group inline-flex items-center gap-3 rounded-full pl-6 pr-2 py-2 text-sm font-semibold transition-colors duration-300 ${STYLES[variant]} ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <span className="grid h-9 w-9 place-items-center rounded-full bg-black/10 transition-transform duration-500 group-hover:rotate-45">
        <ArrowUpRight className="h-4 w-4" />
      </span>
    </>
  );
  if (href) return <a href={href} className={cls} data-testid={testId} {...rest}>{inner}</a>;
  return <Link to={to} className={cls} data-testid={testId} {...rest}>{inner}</Link>;
};
